import styled from "styled-components";

export const ActionButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
    @media (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
        margin-top: 0px;
        margin-bottom: 0px;

        button {
            width: 100%;
        }
    }
`;
